import React from "react";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import GeometryEditing from "../geometry-editing";

const GeometryCreator = () => {
  const { selectedCity } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  return (
    <GeometryEditing
      modalMessages={{
        positive: "editing-block.modalMessagePositiveCreator",
        negative: "editing-block.modalMessageNegativeCreator",
      }}
      modalTitle="editing-block.modalTitleCreator"
      validationFlags={{
        selfIntersections: true,
        duplicatePoints: true,
        intersections: true,
        outsideCityBoundary: {
          cityId: selectedCity!,
        },
      }}
      addEmptyContourOnMount={true}
      shouldFocusOnFeature={false}
    />
  );
};

export default GeometryCreator;
